export var adaptImages = function adaptImages(images) {
  return images.map(function (_ref) {
    var url = _ref.url,
        sizes = _ref.sizes,
        srcSet = _ref.srcSet,
        title = _ref.title,
        placeholderUrl = _ref.placeholderUrl;
    return {
      original: url,
      originalAlt: title,
      originalTitle: title,
      thumbnail: url,
      placeholder: placeholderUrl || url,
      thumbnailAlt: title,
      sizes: sizes,
      srcSet: srcSet
    };
  });
};